<template>
  <div class="edit-deliverable-modal" :class="(!userAbilities.editMediaCall || deliverableDetail.permissions.viewOnly) ? 'read-only' : ''" v-show="deliverableDetail">
    <div class="departments__wrapper">
      <!-- Deliverable type -->
      <div v-if="!canChangeDeliverableType()" class="data-items department-title">
        <span>
          {{ deliverableTypeTitle(deliverableDetail.deliverable_template_id) }}
        </span>
      </div>
      <div v-else class="data-items department-title deliverable-type-link" data-toggle="dropdown">
        <span>
          {{ deliverableTypeTitle(deliverableDetail.deliverable_template_id) }}
        </span>
        <div class="dropdown-menu" style="text-transform: none">
          <a class="dropdown-item" href="#" v-for="(type,i) in deliverableTypes" :key="i" @click.prevent="changeDeliverableType(deliverableDetail, type)">{{type.name}}</a>
        </div>
      </div>
      <DeliverableDepartments v-if="isMobile() && showDepartment()" :deliverable="deliverableDetail" />
      <DeliverableProjects :deliverable="deliverableDetail" />
    </div>
    <label v-if="isMobile()" class="form-group w-100 sticky__delv__title">
      <h1
      @click="activateTitleField"
      class="exclude-outside-click edit-d-title deliverable-title"
      v-show="!editTitle"
      >{{ deliverableDetail.title || 'Click to set...' }}</h1>
      <textarea
      v-click-outside="outside"
      ref="deliverableTitle"
      v-show="editTitle"
      v-model="deliverableDetail.title"
      type="text"
       :placeholder="getDeliverableTitlePlaceholder"
      class="form-control mb-3 title-field exclude-outside-click h1"
      @change="updateDeliverableTitle"
        @blur="editTitle=false;"></textarea>
    </label>
    <div class="row">
      <div class="col-md-5">
        <DeliverableDepartments v-if="!isMobile() && showDepartment()" :deliverable="deliverableDetail" />
        <label v-if="!isMobile()" class="form-group w-100">
          <h1
          @click="activateTitleField"
          class="exclude-outside-click edit-d-title deliverable-title"
          v-show="!editTitle"
          >{{ deliverableDetail.title || 'Click to set...' }}</h1>
          <textarea
          v-click-outside="outside"
          ref="deliverableTitle"
          v-show="editTitle"
          v-model="deliverableDetail.title"
          type="text"
          :placeholder="getDeliverableTitlePlaceholder"
          class="form-control mb-3 title-field exclude-outside-click h1"
          @change="updateDeliverableTitle"
            @blur="editTitle=false;"></textarea>
        </label>
      </div>
      <!-- <div class="col-md-4">
        <div class="form-group">
          <DeliverableDepartments :deliverable="deliverableDetail" />
        </div>
      </div> -->
      <div class="col-md-7">
        <div class="form-group">
          <div class="tags__wrapper">
            <DeliverableListTags :deliverable="deliverableDetail" />
          </div>
          <div class="trending-tags" v-if="relatedTags.length">
            <label>Trending tags:</label>
            <a
            href="#"
            @click.prevent="setTag(relatedTag)"
            class="badge badge-success ml-2"
            v-for="(relatedTag, index) in relatedTags"
            :key="'relate-tag'+index"
            >{{ relatedTag.name }}</a>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-8">

            <div class="row no-gutters">
              <div class="col-md-12">
                <div
                class="field-box"
                v-for="(field, index) in _.filter(deliverableDetail.customFields, {field_key: 'questions'})"
                :key="index"
                >
                <DeliverableCustomFields :deliverable="deliverableDetail" :customField="field" />
              </div>
            </div>
            <div class="col-md-12">
              <div
              class="field-box"
              v-for="(field, index) in _.filter(deliverableDetail.customFields, {field_key: 'responses'})"
              :key="index"
              >
              <DeliverableCustomFields :deliverable="deliverableDetail" :customField="field" />
            </div>
          </div>
          <div class="col-md-12">
            <div
            class="field-box"
            v-for="(field, index) in _.filter(deliverableDetail.customFields, {field_key: 'notes_research'})"
            :key="index"
            >
            <DeliverableCustomFields :deliverable="deliverableDetail" :customField="field" />
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="row no-gutters">
        <div class="col-md-12">
          <div class="row no-gutters" >
            <div class="col-md-12">
              <div
                class="field-box"
                v-for="(field, index) in _.filter(deliverableDetail.customFields, {field_key: 'priority'})"
                :key="index"
                >
                <DeliverableCustomFields :deliverable="deliverableDetail" :customField="field" />
              </div>
            </div>
            <div class="col-md-12" v-if="hasContactFields()">
              <b-tabs class="field-tabs" content-class="field-tab-content" fill>
                <b-tab class="field-tab-research field-box" active title="Contact">
                  <div class="add-contact-wrapper">
                      <button v-b-tooltip.hover title="Add spokesperson" class="add-contact-button exclude-outside-click d-inline-block" @click="showAddSpokesperson">Spokesperson</button>
                      <plus-button @click="showAddSpokesperson"></plus-button>
                      <div v-show="addSpokespersonFlag" class="custom-multiselect" v-click-outside="outside">
                          <autocomplete
                            :debounce-time="500"
                            v-show="addSpokespersonFlag"
                            class="multiselect"
                            :search="onSpokespersonSearch"
                            @focus="onSpokespersonSearch(false)"
                            @submit="onSpokespersonSelect"
                            placeholder="Start typing to select spokesperson"
                            aria-label="Start typing to select spokesperson"
                            ref="searchSpokesperson"
                            auto-select
                          >
                              <template v-slot:result=" {result, props } ">
                                  <li v-bind="props" class="autocomplete-result contact-result multiselect__element" v-if="result.id == null">
                                      <div class="option_add" v-html="result.label"></div>
                                  </li>
                                  <li v-bind="props" class="autocomplete-result contact-result multiselect__element" v-if="result.id">
                                      <div class="option__desc">
                                          <div class="option__name exclude-outside-click">{{result.first_name}} {{result.last_name}}</div>
                                          <div class="option__company exclude-outside-click">{{result.company_name}}</div>
                                          <div class="option__phone exclude-outside-click">{{result.phone}}</div>
                                      </div>
                                  </li>
                              </template>
                          </autocomplete>
                      </div>

                      <div class="contact-box" v-for="(contact, index) in _.filter(deliverableDetail.customFields, {field_key: 'spokesperson'})" :key="'spokesperson-'+index" v-if="contact.value">
                          <div class="contact-box__name">
                              {{ contact.contactData.name }}
                              <a v-if="!(!userAbilities.editMediaCall || deliverableDetail.permissions.viewOnly)" v-b-tooltip.hover title="Edit spokesperson" class="edit-contact-btn" href="#" @click.prevent="updateContact(contact.contactData, 'spokesperson')">
                                  <i class="fas fa-edit"></i>
                              </a>
                          </div>
                          <div v-if="contact.contactData.position" class="contact-box__position">{{ contact.contactData.position }}</div>
                          <div v-if="contact.contactData.company_name" class="contact-box__company_name">{{ contact.contactData.company_name }}</div>
                          <div v-if="contact.contactData.phone" class="contact-box__phone"><a :href="Format.hrefPhone(contact.phone)">T: {{contact.phone}}</a></div>
                          <div v-if="contact.contactData.cell_phone" class="contact-box__cell_phone"><a :href="Format.hrefPhone(contact.cell_phone)">M: {{contact.cell_phone}}</a></div>
                          <div v-if="contact.contactData.fax" class="contact-box__fax">F:{{ contact.contactData.fax }}</div>
                          <div v-if="contact.contactData.email_address" class="contact-box__email"><a :href="Format.hrefEmail(contact.email_address)">{{contact.email_address}}</a></div>
                          <div v-if="contact.contactData.address" class="contact-box__address">{{ contact.contactData.address }}</div>
                          <div v-if="contact.contactData.city" class="contact-box__city">{{ contact.contactData.city }}</div>
                          <div v-if="contact.contactData.province" class="contact-box__province">{{ contact.contactData.province }}</div>
                          <div v-if="contact.contactData.country_id" class="contact-box__country_id">{{ contact.contactData.country_id }}</div>
                          <div v-if="contact.contactData.postal_code" class="contact-box__postal_code">{{ contact.contactData.postal_code }}</div>
                          <div v-if="contact.contactData.region" class="contact-box__region">{{ contact.contactData.region }}</div>
                          <div v-if="contact.contactData.notes" class="contact-box__notes">{{ contact.contactData.notes }}</div>
                      </div>
                  </div>

                  <div class="add-contact-wrapper">
                      <button v-b-tooltip.hover title="Add contact" class="add-contact-button exclude-outside-click d-inline-block" @click="showAddWho">{{deliverableContactsLabel(deliverableDetail.deliverable_template_id)}}</button>
                      <plus-button @click="showAddWho"></plus-button>
                      <div v-show="addWhoFlag" class="custom-multiselect" v-click-outside="outside">
                          <autocomplete
                              :debounce-time="500"
                              v-show="addWhoFlag"
                              class="multiselect"
                              :search="onWhoSearch"
                              @submit="onWhoSelect"
                              placeholder="Start typing to select outlet / contact"
                              aria-label="Start typing to select outlet / contact"
                              ref="searchWho"
                              auto-select
                          >
                              <template v-slot:result=" {result, props } ">
                                  <li v-bind="props" class="autocomplete-result contact-result multiselect__element" v-if="result.id == null">
                                      <div class="option_add" v-html="result.label"></div>
                                  </li>
                                  <li v-bind="props" class="autocomplete-result contact-result multiselect__element" v-if="result.id">
                                      <div class="option__desc">
                                          <div class="option__name exclude-outside-click">{{result.first_name}} {{result.last_name}}</div>
                                          <div class="option__company exclude-outside-click">{{result.company_name}}</div>
                                          <div class="option__phone exclude-outside-click">{{result.phone}}</div>
                                      </div>
                                  </li>
                              </template>
                          </autocomplete>
                      </div>

                      <div class="contact-box" v-for="(contact, index) in _.filter(deliverableDetail.customFields, {field_key: 'who'})" :key="'who-'+index" v-if="contact.value">
                          <div class="contact-box__name">
                              {{ contact.contactData.name }}
                              <a v-if="!(!userAbilities.editMediaCall || deliverableDetail.permissions.viewOnly)" v-b-tooltip.hover title="Edit contact" class="edit-contact-btn" href="#" @click.prevent="updateContact(contact.contactData, 'who')">
                                  <i class="fas fa-edit"></i>
                              </a>
                          </div>
                          <div v-if="contact.contactData.position" class="contact-box__position">{{ contact.contactData.position }}</div>
                          <div v-if="contact.contactData.company_name" class="contact-box__company_name">{{ contact.contactData.company_name }}</div>
                          <div v-if="contact.contactData.phone" class="contact-box__phone"><a :href="Format.hrefPhone(contact.phone)">T: {{contact.phone}}</a></div>
                          <div v-if="contact.contactData.cell_phone" class="contact-box__cell_phone"><a :href="Format.hrefPhone(contact.cell_phone)">M: {{contact.cell_phone}}</a></div>
                          <div v-if="contact.contactData.fax" class="contact-box__fax">F:{{ contact.contactData.fax }}</div>
                          <div v-if="contact.contactData.email_address" class="contact-box__email"><a :href="Format.hrefEmail(contact.email_address)">{{contact.email_address}}</a></div>
                          <div v-if="contact.contactData.address" class="contact-box__address">{{ contact.contactData.address }}</div>
                          <div v-if="contact.contactData.city" class="contact-box__city">{{ contact.contactData.city }}</div>
                          <div v-if="contact.contactData.province" class="contact-box__province">{{ contact.contactData.province }}</div>
                          <div v-if="contact.contactData.country_id" class="contact-box__country_id">{{ contact.contactData.country_id }}</div>
                          <div v-if="contact.contactData.postal_code" class="contact-box__postal_code">{{ contact.contactData.postal_code }}</div>
                          <div v-if="contact.contactData.region" class="contact-box__region">{{ contact.contactData.region }}</div>
                          <div v-if="contact.contactData.notes" class="contact-box__notes">{{ contact.contactData.notes }}</div>
                      </div>
                  </div>
              </b-tab>
              <b-tab class="field-tab-chat" title="Chat" disabled>
                <div class="dummy-chat">
                  <img class="logo" src="@/csmworkflow/img/dummy-chat.svg" />
                  <b-form-input type="text" class="input-new-chat-message" placeholder="Enter comment..."></b-form-input>
                </div>
              </b-tab>
            </b-tabs>
          </div>
   <div class="col-md-12">
      <div
        class="field-box"
        v-for="(field, index) in _.filter(deliverableDetail.customFields, {field_key: 'start_date'})"
        :key="index"
        >
        <DeliverableCustomFields :deliverable="deliverableDetail" :customField="field" />
      </div>
    </div>
          
  <div class="col-md-12 field-box">
    <div class="field-box__header">
      <div class="dropdown">
        <button
        v-b-tooltip.hover
        title="Add resource"
        class="add-resource-button exclude-outside-click d-inline-block"
        data-toggle="dropdown" aria-expanded="false"
        data-reference="parent"
        >Resources</button>
        <plus-button data-toggle="dropdown" aria-expanded="false" data-reference="parent"></plus-button>
        <div class="dropdown-menu deliverable-resource-type-menu">
          <a class="dropdown-item" href="#" v-for="(type,i) in optionsForLinkType" :key="i" @click="addResourceMenuItemClick(type.id, $event)"><img class="link-type-icon" :src="require(`@/csmworkflow/img/${type.icon}`)"> {{type.name}}</a>
        </div>
      </div>
    </div>
      <div class="field-box__content">
          <!-- <div style="padding-top: 1em; border-bottom: 1px solid #eee;">
            <VueFilePond
              name="file"
              ref="resourcePond"
              label-idle="Drop files here or Click to select files"
              :allow-multiple="true"
              :dropOnElement="true"
              :dropOnPage="false"
              :allowRevert="false"
              v-bind:files="filepond"
              v-on:init="handleFilePondInit"
            />
          </div> -->
          <div class="resource-box"
          v-for="(resource, index) in _.filter(deliverableDetail.customFields, {field_key: 'link_url'})"
          :key="'link_url-'+index"
          >
          <div class="media">
            <img class="link-type-icon" style="margin-right: 3px" :src="require(`@/csmworkflow/img/${getLinkTypeObject(customChildFieldValue('link_type',resource.id)).icon}`)" draggable="false">
            <div class="media-body">
              <!-- <div class="resource-box__url" @click="setCookieForDownload()"></div> -->
              <div class="resource-box__url"></div>
                <a :href="resource.value" @click="openCopyLinkModal(resource.value, $event, index)" target="blank" :id="`resource-${index}`">{{customChildFieldValue('link_label',resource.id) || resource.value}}</a>
                <b-tooltip :target="`resource-${index}`" noninteractive triggers="manual"><i class="fas fa-check" style="color:#4C9850;"></i> Link Copied!</b-tooltip>
                <a
                v-b-tooltip.hover
                title="Edit resource"
                class="edit-resource-btn"
                href="#"
                v-if="!(!userAbilities.editMediaCall || deliverableDetail.permissions.viewOnly)"
                @click.prevent="editResource(resource)"
                >

                <i class="fas fa-edit"></i>
              </a>
              <div class="resource-box__notes" v-if="customChildFieldValue('link_notes',resource.id)">{{customChildFieldValue('link_notes',resource.id)}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>




</div>




          <!-- <div class="col-md-12">
            <div
              v-for="(field, index) in _.filter(deliverableDetail.customFields, {field_key: 'attachments'})"
              :key="index"
            >
              <DeliverableCustomFields :customField="field" />
            </div>
          </div>-->
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-3"></div>
</div>
<div class="row">
  <div class="col-md-12">
    <div class="add-task-button-mobile">
      <b-button v-if="!(!userAbilities.editMediaCall || deliverableDetail.permissions.viewOnly)" variant="theme" class="add-task-btn" @click.stop="createTask">
          Add Task
          <div role="status" v-show="addingTask" class="ml-2 spinner-border spinner-border-sm text-primary"><span class="sr-only">Loading...</span></div>
      </b-button>
    </div>
    <TaskFieldLabels ref="TaskFieldLabelsRef" :fullDeliverables="deliverableDetail" :deliverableId="deliverableDetail.deliverableId" :deliverable="deliverableDetail" :tasks="deliverableDetail.tasks" />
    <TaskFields :fullDeliverables="deliverableDetail" :deliverableId="deliverableDetail.deliverableId" :deliverable="deliverableDetail" :tasks="deliverableDetail.tasks" />
  </div>
</div>

<div :class="showModalOptions ? 'open' : ''" class="responsive-edit-modal-controls">
  <button
  v-b-tooltip.hover
  title="More options"
  @click="showModalOptions=!showModalOptions"
  class="btn modal-more-controls"
  >
    <i class="fas" :class="!showModalOptions ? 'fa-arrow-left' : 'fa-arrow-right'"></i>
  </button>
  


  <button
  v-b-tooltip.hover
  :title="getDeleteDeliverableTitle"
  @click="removeDeliverable(deliverableDetail.deliverableId)"
  class="btn delete-deliverable-btn"
  v-if="userAbilities.deleteMediaCall && !deliverableDetail.permissions.viewOnly"
  >
    <i class="fas fa-trash-alt"></i>
  </button>

  <DuplicateMediaCallBtn :deliverableId='deliverableDetail.deliverableId' />
  <FeedbackBtn />
  <button
  v-b-tooltip.hover
  title="Close"
  @click="onCloseModal"
  class="btn close-deliverable-btn"
  >
    <i class="fas fa-times"></i>
  </button>
</div>
<b-modal v-model="showRemoveDeliverable" type="warn" title="Confirm Deletion" @ok="onConfirmRemoveDeliverable" ok-title="Yes, Delete">
  <p>Are you sure you want to delete this deliverable?</p>
</b-modal>
<b-modal v-model="showRemoveContact" type="warn" title="Confirm Contact Removal" @ok="onConfirmRemoveContact" ok-title="Yes, Remove">
  <p>Are you sure you want to unassign this contact?</p>
</b-modal>

<b-modal v-model="showRemoveSpokesperson" type="warn" title="Confirm Contact Removal" @ok="onConfirmRemoveSpokesperson" ok-title="Yes, Remove">
  <p>Are you sure you want to unassign this spokesperson?</p>
</b-modal>
<b-modal v-model="showRemoveWho" type="warn" title="Confirm Contact Removal" @ok="onConfirmRemoveWho" ok-title="Yes, Remove">
  <p>Are you sure you want to unassign this outlet?</p>
</b-modal>


<b-modal centered  hide-footer id="createLinkModal" title="New Resource / Link" @shown="focusLinkModal">
  <CreateLinkModal  ref="refLinkModal" v-bind:link-url="linkUrl" v-bind:link-label="linkLabel" v-bind:link-notes="linkNotes" v-bind:link-type="linkType" />
</b-modal>
<b-modal hide-footer id="editLinkModal" title="Update Resource / Link" @shown="focusEditLinkModal">
  <EditLinkModal  ref="refEditLinkModal" v-bind:link-url="linkUrl" v-bind:link-label="linkLabel" v-bind:link-notes="linkNotes" v-bind:link-type="linkType" v-bind:is-file="editLinkIsFile" />
</b-modal>
<b-modal centered id="linkCopyLinkModal" title="Copy Link" ok-only ok-title="Done">
  <LinkCopyLinkModal :linkUrl="linkCopyModalValue" />
</b-modal>

</div>
</template>

<script>
import DeliverableCustomFields from "../common/DeliverableCustomField";
import FullContactField from "../common/FullContactField";
import TaskFields from "./TaskFields";
import TaskFieldLabels from "./TaskFieldLabels";
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import UpdateContactModal from "./EditContactModal";
import DeliverableListTags from "./DeliverableListTags";
import DeliverableProjects from "./DeliverableProjects";
import DeliverableDepartments from "./DeliverableDepartments";
import Format from "../../utility/Format";
import Autocomplete from '@trevoreyre/autocomplete-vue'
import CreateLinkModal from "./CreateLinkModal";
import FeedbackBtn from "../common/FeedbackBtn"
import DuplicateMediaCallBtn from "../common/DuplicateMediaCallBtn"
import EditLinkModal from "./EditLinkModal";
import toast from "../../toast";
import LinkCopyLinkModal from "../common/LinkCopyLinkModal.vue";

import vueFilePond from "vue-filepond";
const VueFilePond = vueFilePond();
import "filepond/dist/filepond.min.css";


export default {
  data() {
    return {
      Format,
      showModalOptions: false,
      renderCount: 1,
      newContactId: "",
      newContactName: "",
      editTitle: false,
      addingTask: true,
      addContactFlag: false,
      addWhoFlag:false,
      addSpokespersonFlag:false,
      showRemoveDeliverable: false,
      showRemoveContact:false,
      showRemoveSpokesperson:false,
      showRemoveWho:false,
      showRemoveResource:false,
      addResourceFlag:false,
      contacts:[],
      linkUrl:null,
      linkLabel:null,
      linkNotes:null,
      linkType:null,
      filepond: [],
      editLinkIsFile: false,
      linkCopyModalValue: "",
      linkCopyLinkTimeouts: {},
    };
  },
  components: {
    DeliverableProjects,
    DeliverableCustomFields,
    TaskFields,
    TaskFieldLabels,
    UpdateContactModal,
    DeliverableListTags,
    DeliverableDepartments,
    FullContactField,
    Autocomplete,
    EditLinkModal,
    FeedbackBtn,
    DuplicateMediaCallBtn,
    CreateLinkModal,
    VueFilePond,
    LinkCopyLinkModal,
  },
  props: ["allContacts", "modalId"],
  computed: {
    ...mapGetters([
    "allDepartments",
    "allSubjects",
    "deliverableDetail",
    "allTags",
    "allRegions",
    "deliverableContactsLabel",
    "allCustomFields",
    "initialContacts",
    "userAbilities",
    "deliverableTypes",
    "allCustomFields"
    ]),
    // so that we can use lodash in the template
    _() {
      return _;
    },
    getDeliverableTitlePlaceholder() {
    	if (this.deliverableDetail) {
        const deliverableTypeObj = this.deliverableTypes.find(x => x.typeId == this.deliverableDetail.deliverable_template_id);
	    	if (this.deliverableDetail.deliverable_template_id == 1) {
	    		return "Media call title...";
	    	} else {
          if (deliverableTypeObj) {
            return deliverableTypeObj.name + " title...";
          } else {
            return "Deliverable title...";
          }
	    	}
	    }
    },

    getDeleteDeliverableTitle() {
    	if (this.deliverableDetail) {

        const deliverableTypeObj = this.deliverableTypes.find(x => x.typeId == this.deliverableDetail.deliverable_template_id);
	    	if (this.deliverableDetail.deliverable_template_id == 1) {
	    		return "Delete Media Call";
	    	} else {
          if (deliverableTypeObj) {
            return "Delete " + deliverableTypeObj.name;
          } else {
            return "Delete Deliverable";
          }
	    	}
	    }
    },


    apiUrl() {
      return process.env.MIX_API_BASE_URL;
    },
    relatedTags() {
      let trendingTags = this.$store.state.deliverables.trendingTags,
      relatedTags = [];
      if (typeof this.deliverableDetail.tags != "undefined") {
        this.deliverableDetail.tags.forEach(deliverableTag => {
          trendingTags = _.reject(trendingTags, function(e) {
            return e.id == deliverableTag.id;
          });
        });
      }
      return trendingTags;
    },

    optionsForLinkType() {
      let linkTypeField = this.allCustomFields.find(x => x.id == 37);
      if (!linkTypeField) {
        this.$store.dispatch("fetchAllCustomFields");
      } else {
        console.log(linkTypeField);
        return JSON.parse(linkTypeField.value_set);
      }
		},
  },
  methods: {
    ...mapActions([
    "updateFieldValue",
    "createTag",
    "removeDeliverableContact",
    "removeDeliverableWho",
    "removeDeliverableSpokesperson"
    ]),
    ...mapMutations([
      "setDeliverable",
      "setDeliverableDetail"
    ]),
    updateDeliverableTitle() {
      this.deliverableDetail.title = Format.replaceLineBreaks(this.deliverableDetail.title, " ");
      this.updateFieldValue(this.deliverableDetail);
    },

    getParentId(obj) {
      if (obj) {
        if (obj.parent_id) {
          return obj.parent_id;
        }
      }
      return null;
    },
    outside() {
      this.editTitle = false;
      this.addContactFlag = false;
      this.addSpokespersonFlag = false;
      this.addWhoFlag = false;
    },
    showAddContact() {
      this.addContactFlag = true;
      this.$nextTick(() => {
        this.$refs.deliverableContacts.$el.focus();
      });
    },
    showAddResource() {
      this.addResourceFlag = true;
      this.$nextTick(() => {
        // this.$refs.deliverableResources.$el.focus();

      });
    },

    showAddWho() {
      if(!this.userAbilities.editMediaCall || this.deliverableDetail.permissions.viewOnly) return;
      this.clearFlags();
      this.addWhoFlag = true;
      this.$nextTick(() => {
        this.$refs.searchWho.$refs.input.focus();
      });
    },
    clearFlags() {
      this.addSpokespersonFlag = false;
      this.addWhoFlag = false;
    },
    showAddSpokesperson() {
      if(!this.userAbilities.editMediaCall || this.deliverableDetail.permissions.viewOnly) return;
      this.clearFlags();
      this.addSpokespersonFlag = true;
      this.$nextTick(() => {
        this.$refs.searchSpokesperson.$refs.input.focus();
      });
    },
    onContactSearch(input) {
      this.isLoading = true;
      this.contacts = [];
      if (input.length < 1) {
        this.isLoading = false;
      }  else {
        axios.get(process.env.MIX_API_BASE_URL + "contacts?q=" + encodeURI(input))
        .then(resp => {
          this.contacts = [];
          for(var contact of resp.data) {
            contact.name = contact.first_name +  " " + contact.last_name;
            contact.commaName = contact.last_name + ", " + contact.first_name;
            this.contacts.push(contact);
          }
          this.isLoading = false;
        })
      }
    },
    contactCustomLabel ({ name, company_name }) {
      if (company_name != null) {
        return `${name} – ${company_name}`
      } else {
        return `${name}`
      }
    },

    onSpokespersonSearch(input) {
      // if(!input && this.initialContacts.length > 0) {
      //     return this.initialContacts;
      // } else {
        return new Promise((resolve, reject) => {
          input = input == false ? '' : input
          axios.get(process.env.MIX_API_BASE_URL + "activeContacts?q=" + encodeURI(input))
          .then(resp => {
            let contacts = [];
            let x = 0;
            contacts.push({id:null,label:"Create new contact <strong>"+input+"</strong>", search:input, deliverablId:this.deliverableDetail.deliverableId});
            for (x = 0 ; x < resp.data.length; x++) {
              contacts.push(resp.data[x]);
            }
            this.$store.commit('setInitialData', {contacts: contacts})
            resolve(contacts);
          })
          .catch(error => {
            reject(error)
          })
        }) 
      // }
    },
    onSpokespersonSelect(selected) {
      console.log('jere');
      if (selected.id == null) {
          // add new contact..
          this.newContactId = null;
          this.createSpokesperson(selected.search, this.deliverableDetail.deliverableId);
        } else {
          this.newContactId = selected;
          this.inputAddContact('spokesperson');
        }
        this.$refs.searchSpokesperson.value = null;
        this.addSpokespersonFlag = false;
      },



      onWhoSearch(input) {
        // if(input == '' && this.initialContacts.length > 0) {
        //   return this.initialContacts;
        // } else {
          return new Promise((resolve, reject) => {
            input = input == false ? '' : input
            axios.get(process.env.MIX_API_BASE_URL + "activeContacts?q=" + encodeURI(input))
            .then(resp => {
              let contacts = [];
              let x = 0;
              contacts.push({id:null,label:"Create new contact <strong>"+input+"</strong>", search:input, deliverablId:this.deliverableDetail.deliverableId});
              for (x = 0 ; x < resp.data.length; x++) {
                contacts.push(resp.data[x]);
              }
              this.$store.commit('setInitialData', {contacts: contacts})
              resolve(contacts);
            })
            .catch(error => {
              reject(error)
            })
          })
        // }
      },
      onWhoSelect(selected) {
        if (selected.id == null) {
          // add new contact..
          this.newContactId = null;
          this.createWho(selected.search, this.deliverableDetail.deliverableId);
        } else {
          this.newContactId = selected;
          this.inputAddContact('who');
        }
        this.$refs.searchWho.value = null;
        this.addWhoFlag = false;
      },

      getResourceValue(url, parent_id) {
        let label = this.customChildFieldValue('link_label',parent_id);
        let notes = this.customChildFieldValue('link_notes',parent_id);
        let fileId = this.customChildFieldValue('file_id',parent_id);
        if (url == null && fileId != null && label) {
          return `<a href="${this.apiUrl}downloadFileDeliverable/${this.deliverableDetail.id}/${fileId}" target="blank">${label}</a>`
        }
        if (url != "" && label != "" && label) {
          return "<a href=\""+url+"\" @click.prevent=\"openCopyLinkModal(\""+url+"\")\" target=\"blank\">"+label+"</a>";
        }
        if (url != "" && url) {
          return "<a href=\""+url+"\" target=\"blank\">"+url+"</a>";
        }
        if (label != "" && label) {
          return label;
        }
        return "";
      },

      openCopyLinkModal(link, e, i) {
        if (!link.includes("\\")) {
          return;
        }
        e.preventDefault();
        // this.linkCopyModalValue = link;
        // this.$bvModal.show("linkCopyLinkModal");
        this.copyLink(link, i);
      },
      async copyLink(link, resourceId) {
        clearTimeout(this.linkCopyLinkTimeouts[resourceId]);
        Object.keys(this._.filter(this.deliverableDetail.customFields, {field_key: 'link_url'})).forEach(x => {
          if (x == resourceId) return;
          this.$root.$emit('bv::hide::tooltip', 'resource-' + x);
        })

        const navPer = await navigator.permissions.query({name: "clipboard-write"});
        if (navPer.state == "granted" || navPer.state == "prompt") {
            try {
                await navigator.clipboard.writeText(link);
            } catch {
                console.error("clipboard API error. Cannot copy to clipboard.");
                this.legacyCopyMethod(link);
            }
        } else {
          this.legacyCopyMethod(link);
        }

        this.$root.$emit('bv::show::tooltip', 'resource-' + resourceId);
        this.linkCopyLinkTimeouts[resourceId] = setTimeout(() => {
          this.$root.$emit('bv::hide::tooltip', 'resource-' + resourceId);
        }, 2000);
      },
      legacyCopyMethod(link) {
        let tempInput = document.createElement("input");
        tempInput.style = "position: absolute; left: -1000px; top: -1000px; z-index: -9999";
        tempInput.value = link;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);
      },


      customChildField(key, parent_id) {
        if (this.deliverableDetail.customFields) {
          let obj = _.filter(this.deliverableDetail.customFields, {field_key: key, parent_id:parent_id});
          if (obj.length > 0) {
            // lets add it to the
            return obj;
          } else {
            // return the global version of the custom field...
            // let obj = _.filter(this.allCustomFields, {field_key: key});
            let field = _.filter(this.allCustomFields, {field_key: key});


            if (typeof this.deliverableDetail.customFields[key] == "undefined") {
            	return null;
            } else {
	            obj = {};
	            obj.id = null;
	            obj.parent_id = this.deliverableDetail.customFields[key].id;
	            obj.deliverable_id = this.deliverableDetail.customFields[key].deliverable_id;
	            obj.editing = false;
	            obj.field_id = field[0].id;
	            obj.field_key = field[0].field_key;
	            obj.field_parent_id = field[0].parent_id;
	            obj.field_type = field[0].field_type;
	            obj.note = field[0].note;
	            obj.value = null;
	            obj.label = field[0].label;
	            obj.value_set = field[0].value_set;
	            obj.updated_at = this.deliverableDetail.customFields[key].updated_at;
	           }
	           return [obj];
          }
      }
      return [];
    },


    customChildFieldValue(key, parent_id) {
      if (this.deliverableDetail.customFields) {
        let obj = _.filter(this.deliverableDetail.customFields, {field_key: key, parent_id:parent_id});
        if (obj != null) {
	        if (obj.length > 0) {
	          return obj[0].value;
	        } else {
	          return null;
	        }
	      }
      }
      return null;
    },



    createContact(newContactName) {
      this.$store.state.newContactName = newContactName;
      this.$store.state.deliverableId = deliverableId;
      this.$store.state.currentFieldKey = 'who';
      this.$bvModal.show("createContactModal");
      //this.$store.commit("toggleAddContactModal");
    },
    createSpokesperson(newContactName, deliverableId) {
      this.$store.state.newContactName = newContactName;
      this.$store.state.deliverableId = deliverableId;
      this.$store.state.currentFieldKey = 'spokesperson';
      this.$bvModal.show("createSpokespersonModal");
      //this.$store.commit("toggleAddContactModal");
    },
    createWho(newContactName, deliverableId) {
      this.$store.state.newContactName = newContactName;
      this.$store.state.deliverableId = deliverableId;
      this.$store.state.currentFieldKey = 'who';
      this.$bvModal.show("createWhoModal");
      //this.$store.commit("toggleAddContactModal");
    },

    updateContact(contactData, fieldKey) {
      this.$store.state.currentContactData = contactData;
      this.$store.state.currentContactId = contactData.id;
      this.$store.state.currentFieldKey = fieldKey;
      if (fieldKey == 'who') {
        this.$bvModal.show("editWhoModal");
      }
      if (fieldKey == 'spokesperson') {
        this.$bvModal.show("editSpokespersonModal");
      }
      //this.$store.commit("toggleEditContactModal");
    },


    editResource(resource) {
      this.linkUrl = resource;
      let label =  this.customChildField('link_label', resource.id);
      if (label.length > 0) {
        this.linkLabel = label[0];
      } else {
        this.linkLabel = {};
      }
      let notes =  this.customChildField('link_notes', resource.id);
      if (notes.length > 0) {
        this.linkNotes = notes[0];
      } else {
        this.linkNotes = {};
      }
      let type =  this.customChildField('link_type', resource.id);
      if (type && type.length > 0) {
        this.linkType = type[0];
      } else {
        this.linkType = {
          id:null,
          field_id:37,
          parent_field_id:20,
          field_key:"link_type",
          field_type:"select",
          parent_id:null,
          deliverable_id:this.deliverableDetail.deliverableId,
          value:1
        };
      }
      let fileId = this.customChildField('file_id', resource.id);
      this.editLinkIsFile = Boolean(fileId);
      this.$bvModal.show("editLinkModal");
    },


    addResource(typeId = 1) {
      if(!this.userAbilities.editMediaCall || this.deliverableDetail.permissions.viewOnly) return;
      this.linkUrl = {
        id:null,
        field_id:20,
        parent_field_id:null,
        field_key:"link_url",
        field_type:"text",
        parent_id:null,
        deliverable_id:this.deliverableDetail.deliverableId,
        value:null
      };
      this.linkLabel = {
        id:null,
        field_id:21,
        parent_field_id:20,
        field_key:"link_label",
        field_type:"text",
        parent_id:null,
        deliverable_id:this.deliverableDetail.deliverableId,
        value:null
      };
      this.linkNotes = {
        id:null,
        field_id:22,
        parent_field_id:20,
        field_key:"link_notes",
        field_type:"text",
        parent_id:null,
        deliverable_id:this.deliverableDetail.deliverableId,
        value:null
      };
      this.linkType = {
        id:null,
        field_id:37,
        parent_field_id:20,
        field_key:"link_type",
        field_type:"select",
        parent_id:null,
        deliverable_id:this.deliverableDetail.deliverableId,
        value:typeId
      };
      this.$bvModal.show("createLinkModal");
    },
    addResourceMenuItemClick(typeId, e) {
      e.preventDefault();
      this.addResource(typeId);
    },



    contactsNotAdded(field_key) {
      let addedContacts = _.filter(this.deliverableDetail.customFields, {
        field_key: field_key
      }),
      allContacts = this.allContacts,
      addedIds = [];

      _.forEach(addedContacts, function(n, key) {
        addedIds.push(parseInt(n.value));
      });
      let result = _.reject(allContacts, function(o) {
        return addedIds.indexOf(o.id) != -1;
      });

      return result;
    },
    inputAddContact(field_key) {
      let x = 0;
      let field_id = null;
      for(x = 0; x < this.deliverableDetail.customFields.length; x++) {
        if (this.deliverableDetail.customFields[x].field_key == field_key) {
          field_id = this.deliverableDetail.customFields[x].field_id;
          break;
        }
      }
      this.newContactId.fieldId = field_id;
      switch(field_key) {
        case "who":
        this.addDeliverableWho({contactData: this.newContactId, deliverableId: this.deliverableDetail.deliverableId});
        break;
        case "spokesperson":
        this.addDeliverableSpokesperson({contactData: this.newContactId, deliverableId: this.deliverableDetail.deliverableId});
        break;
        default:
      }
    },
    addDeliverableSpokesperson(payload) {
      this.$store.dispatch("addDeliverableSpokesperson", payload);
      this.newContactId = "";
    },
    addDeliverableWho(payload) {
      this.$store.dispatch("addDeliverableWho", payload);
      this.newContactId = "";
    },

    addDeliverableContact(payload) {
      this.$store.dispatch("addDeliverableContact", payload);
      this.newContactId = "";
    },
    removeDeliverable(deliverableId) {
      this.showRemoveDeliverable = true;
    },
    onConfirmRemoveDeliverable() {
      if (this.deliverableDetail.deliverableId) {
        let that = this;
        let deliverableId = this.deliverableDetail.deliverableId;
        let deliverableTemplateId = this.deliverableDetail.deliverable_template_id;
        this.$store.dispatch("removeDeliverable", { deliverableId:this.deliverableDetail.deliverableId }).then(function() {
          that.$bvModal.hide("editDeliverableModal");
          // TODO: removing a deliverable should only remove it from the list, not replace entire list.
          // that.$store.commit('removeMediaCallFromList', deliverableId);
          // that.$store.dispatch('countOutlets');

          that.$store.dispatch('fetchDeliverables').then(function() {
            toast.hide();

            if (deliverableTemplateId == 1) {
            	that.$store.dispatch('manageUndoActivation', 'Media call deleted.');
            } else {
            	that.$store.dispatch('manageUndoActivation', 'Deliverable deleted.');
            }

          	that.$store.dispatch('fetchProjectDeliverable');
          });
        });
      }
    },
    showRemoveDeliverableContact(contactId) {
      this.contactId = contactId;
      this.showRemoveContact = true;
    },
    onConfirmRemoveContact() {
      if (this.contactId) {
        this.removeDeliverableContact(this.contactId);
      }
    },
    focusLinkModal() {
      this.$refs.refLinkModal.focusMyElement();
    },
    focusEditLinkModal() {
      this.$refs.refEditLinkModal.focusMyElement();
    },

    onShowRemoveSpokesperson(contactId) {
      this.contactId = contactId;
      this.showRemoveSpokesperson = true;
    },
    onConfirmRemoveSpokesperson() {
      if (this.contactId) {
        this.removeDeliverableSpokesperson(this.contactId);
      }
    },

    onShowRemoveWho(contactId) {
      this.contactId = contactId;
      this.showRemoveWho = true;
    },
    onConfirmRemoveWho() {
      if (this.contactId) {
        this.removeDeliverableWho(this.contactId);
      }
    },

    onCloseModal() {
        if (this.modalId) {
          this.$bvModal.hide(this.modalId);
        } else { 
          this.$bvModal.hide("editDeliverableModal");
        }
        if(this.$router.currentRoute.name == 'calendar') {
          this.$root.$emit('re__fetch__calendar__data')
        }
    },


    setTag(newTag) {
      if(!this.userAbilities.editMediaCall || this.deliverableDetail.permissions.viewOnly) return;
      // this.renderCount++;
      // this.relatedTags = _.remove(this.relatedTags, function(e) {
      //   return e.id == newTag.id;
      // });
      this.deliverableDetail.tags.push(newTag);
      this.$store.dispatch("updateFieldValue", this.deliverableDetail);
    },

    activateTitleField() {
      if(!this.userAbilities.editMediaCall || this.deliverableDetail.permissions.viewOnly) return;
      let that = this
      this.editTitle=true; 
      setTimeout(function() {
        that.$refs.deliverableTitle.select();
      }, 100)
    },

    hasContactFields() {
      // let r = _.filter(this.deliverableDetail.customFields, {field_type: 'contacts'});

      // Hardcode for now (filter out contacts field will kill the contact box for other deliverable types as well)
      // return this.deliverableDetail.deliverable_template_id != 8;
      return this.deliverableDetail.deliverable_template_id == 1;
    },

    // Hardcode
    showDepartment() {
      // return this.deliverableDetail.deliverable_template_id != 8;
      return this.deliverableDetail.deliverable_template_id == 1;
    },

    // Resource upload file
    handleFilePondInit() {
      this.$refs.resourcePond._pond.setOptions({
        server: {
						headers: {
							Authorization: "Bearer " + this.$store.getters.authToken
						},
						process: {
							method: 'POST',
							url: `${this.apiUrl}uploadFileDeliverable`,
							withCredentials: true,
              ondata: this.handleFilePondSubmit,
              onload: this.handleFilePondSuccess,
          },
        }
      });
    },
    handleFilePondSubmit(data) {
      // data.append('type', 1);
      data.append('id', this.deliverableDetail.id);
      return data;
    },
    handleFilePondSuccess(r) {
      let newDeliverableR = JSON.parse(r);
      this.setDeliverable(newDeliverableR.deliverableDetail);
      this.setDeliverableDetail(newDeliverableR.deliverableDetail);
    },

    setCookieForDownload() {
      this.$store.dispatch("setUserAuthCookie");
    },

    getLinkTypeObject(id) {
      if (id == null) id = 1;
      const r = this.optionsForLinkType.find(x => x.id == id);
      return r;
    },

    createTask() {
      this.$refs.TaskFieldLabelsRef.createTask();
    },

    deliverableTypeTitle(deliverableTypeId) {
			if(this.deliverableTypes) {
				let typeData = _.filter(this.deliverableTypes, {typeId: deliverableTypeId});
				if(typeData.length > 0) {
					return typeData[0].name;
				}
			}
		},
    changeDeliverableType(deliverable, type) {
			if (deliverable.deliverable_template_id == type.typeId) return;
			this.$store.dispatch('changeDeliverableType', {
				id: deliverable.id,
				deliverable_type: type.id,
			});
      // .then(r => {
			// 	this.$store.dispatch('manageUndoActivation', 'Deliverable type changed.');
			// });
		},
		canChangeDeliverableType() {
			if (this.deliverableTypes.length < 2) {
				return false;
			} else {
				return true;
			}
		}
  },
  mounted() {
    $('#editDeliverableModal .modal-content').removeAttr('tabindex');
    if(!this.userAbilities.editMediaCall || this.deliverableDetail.permissions.viewOnly) {
      $('.add-contact-button, .add-resource-button').removeAttr('title').attr('disabled', 'disabled');
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
</style>